import styled from 'styled-components'

const ProductLabel = styled.div<{ lg?: boolean; secondary?: boolean; tertiary?: boolean; exclusive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 21px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  padding: 0 ${({ theme }) => theme.spacing.S};
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.element.white};

  &::after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 4px 0 0 4px;
    border-color: transparent transparent transparent #5c5340;
    position: absolute;
    top: -${({ theme }) => theme.spacing['3XS']};
    right: 0;
  }

  i {
    margin-right: ${({ theme }) => theme.spacing['3XS']};
    font-size: ${({ theme }) => theme.fontSize.sm};
    color: ${(props) => props.theme.colors.white};
  }

  ${({ lg, theme }) =>
    lg
      ? `
    height: 28px;
    padding-right: ${theme.spacing['2XL']};

    i {
      margin-right:  ${theme.spacing['2XS']};
      font-size: ${theme.fontSize.md};
    }

    &::after {
      border-width: 10px 0 0 10px;
      top: -${theme.spacing.S};
    }
  `
      : ''}

  background: ${({ theme }) => theme.colors.primary};

  ${({ secondary, theme }) =>
    secondary
      ? `
    background: ${theme.colors.secondary};
  `
      : ''}

  ${({ tertiary, theme }) =>
    tertiary
      ? `
    background: ${theme.colors.tertiary};
  `
      : ''}
  
  ${({ exclusive, theme }) =>
    exclusive
      ? `
    background: ${theme.colors.success};
  `
      : ''}

  @media (max-width: 371px) {
    padding: 0 ${({ theme }) => theme.spacing['2XS']};
    .product-label-text {
      font-size: 0.55em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    i {
      font-size: 0.5em;
    }
  }
`

export default ProductLabel
